import React, { useState } from 'react'
import {
	EuiButton,
	EuiButtonEmpty,
	EuiFormRow,
	EuiModal,
	EuiModalBody,
	EuiModalFooter,
	EuiModalHeader,
	EuiModalHeaderTitle,
	EuiTextArea,
} from '@equipmentshare/ds2'
import { heapEvent } from '@equipmentshare/heaper'
import { useCancelTransferOrderMutation } from '../../../graphql'
import { useShowError, useShowSuccess } from 'hooks/useToast'

type Props = {
	transferOrderId: string,
	onClose: () => void,
	onSuccess: () => void,
}

export default function CancelTransferOrderModal( { transferOrderId, onClose, onSuccess }: Props ) {
	const [ cancellationNote, setCancellationNote ] = useState( '' )
	const showSuccess = useShowSuccess()
	const showError = useShowError()
	const [ cancelTransferOrder, { loading } ] = useCancelTransferOrderMutation()

	const handleConfirm = async () => {
		try {
			const { data } = await cancelTransferOrder( {
				variables: {
					input: {
						transferOrderId,
						cancellationNote: cancellationNote.trim() || undefined,
					},
				},
			} )

			if ( data?.cancelTransferOrder?.success ) {
				heapEvent( 'Inventory - Transfer Orders - Cancel - Submit - Success', { transfer_order_id: transferOrderId } )
				showSuccess( `cancelTransferOrderSuccess${Date.now()}`, 'Transfer order cancelled.' )
				onSuccess()
			} else {
				heapEvent( 'Inventory - Transfer Orders - Cancel - Submit - Error', { transfer_order_id: transferOrderId } )
				showError( `cancelTransferOrderError${Date.now()}`, data?.cancelTransferOrder?.message ?? 'Failed to cancel transfer order.' )
			}
		} catch {
			heapEvent( 'Inventory - Transfer Orders - Cancel - Submit - Error', { transfer_order_id: transferOrderId } )
			showError( `cancelTransferOrderError${Date.now()}`, 'Failed to cancel transfer order.' )
		}
	}

	return (
		<EuiModal onClose={onClose}>
			<EuiModalHeader>
				<EuiModalHeaderTitle>Cancel Transfer Order</EuiModalHeaderTitle>
			</EuiModalHeader>
			<EuiModalBody>
				<EuiFormRow label="Cancellation Note (optional)">
					<EuiTextArea
						value={cancellationNote}
						onChange={( e ) => setCancellationNote( e.target.value )}
						placeholder="Reason for cancellation..."
						rows={3}
					/>
				</EuiFormRow>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButtonEmpty onClick={onClose}>
					Back
				</EuiButtonEmpty>
				<EuiButton color="danger" fill onClick={handleConfirm} isLoading={loading}>
					Cancel Transfer Order
				</EuiButton>
			</EuiModalFooter>
		</EuiModal>
	)
}
